import React, { useState } from 'react';
import EventList from '../components/EventList/EventList';

const MyEvents = () => {
  const [activeTab, setActiveTab] = useState('upcoming');
  
  const upcomingEvents = [
    {
      id: 1,
      title: 'Annual Events in Mumbai',
      type: 'Dance Event',
      date: '23rd Jan 2023 | 8:00 - 12:00 p.m.',
      location: 'Mumbai, Maharashtra',
      price: 1000,
      status: 'Cancelled',
      image: '/api/placeholder/300/200'
    },
    // Add more events
  ];

  const historyEvents = [
    {
      id: 2,
      title: 'Annual Events in Mumbai',
      type: 'Dance Event',
      date: '20th Jan 2023 | 8:00 - 12:00 p.m.',
      location: 'Mumbai, Maharashtra',
      price: 1000,
      status: 'Successfully Done',
      image: '/api/placeholder/300/200'
    },
    // Add more events
  ];

  return (
    <div style={{ paddingTop: '80px' }}>
      <div className="tabs-container">
        <button 
          className={`tab ${activeTab === 'upcoming' ? 'active' : ''}`}
          onClick={() => setActiveTab('upcoming')}
        >
          Up Coming
        </button>
        <button 
          className={`tab ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => setActiveTab('history')}
        >
          History
        </button>
      </div>
      
      {activeTab === 'upcoming' ? (
        <EventList title="Total Events - 3" events={upcomingEvents} />
      ) : (
        <EventList title="Total Events - 5" events={historyEvents} />
      )}
    </div>
  );
};

export default MyEvents;